import {
    DELETE_SUBCATEGORY_SUCCESS,
    CREATE_SUBCATEGORY,
    CREATE_SUBCATEGORY_LOCALISATION,
    CREATE_SUBCATEGORY_LOCALISATION_SUCCESS,
    FETCH_SUBCATEGORIES,
    FETCH_SUBCATEGORIES_FAILURE,
    FETCH_SUBCATEGORIES_SUCCESS,
    FETCH_SUBCATEGORY,
    FETCH_SUBCATEGORY_FAILURE,
    FETCH_SUBCATEGORY_LOCALISATION,
    FETCH_SUBCATEGORY_LOCALISATION_FAILURE,
    FETCH_SUBCATEGORY_LOCALISATION_SUCCESS,
    FETCH_SUBCATEGORY_SUCCESS,
    SORT_ASC,
    SUBCATEGORIES_LIST_PAGE,
    SUBCATEGORIES_LIST_SORT,
    UPDATE_SUBCATEGORY_LOCALISATION_SUCCESS,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    ids: [],
    field: 'name',
    loading: false,
    localisation: {},
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 24,
    total: 0,
};

export default function subcategories(state = initialState, action) {
    switch (action.type) {
        case CREATE_SUBCATEGORY:
        case CREATE_SUBCATEGORY_LOCALISATION:
        case FETCH_SUBCATEGORIES:
        case FETCH_SUBCATEGORY:
        case FETCH_SUBCATEGORY_LOCALISATION:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_SUBCATEGORY_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
            });

        case CREATE_SUBCATEGORY_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.payload.system,
                }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
                localisation: Object.assign({}, state.localisation, {
                    [action.response.id]: action.payload.localisation,
                }),
            });

        case FETCH_SUBCATEGORY_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                ids: [
                    ...state.ids,
                    ...action.payload.id,
                ],
                loading: false,
                localisation: Object.assign({}, state.localisation, {
                    [action.payload.id]: reducerHelper.formatLocalisations(action.response.results),
                }),
            });

        case UPDATE_SUBCATEGORY_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                ids: [
                    ...state.ids,
                    ...action.payload.id,
                ],
                loading: false,
                localisation: Object.assign({}, state.localisation, {
                    [action.payload.id]: action.response.results,
                }),
            });

        case FETCH_SUBCATEGORIES_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: action.payload.total,
            });

        case FETCH_SUBCATEGORIES_FAILURE:
        case FETCH_SUBCATEGORY_FAILURE:
        case FETCH_SUBCATEGORY_LOCALISATION_FAILURE:
            return Object.assign({}, state, {
                data: {},
                loading: false,
                localisation: {},
            });

        case DELETE_SUBCATEGORY_SUCCESS:
            const {
                id,
            } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedLocalisation = reducerHelper.removeItemFromObject(state.localisation, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                localisation: deletedLocalisation,
                total: state.total - 1,
            });

        case SUBCATEGORIES_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case SUBCATEGORIES_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/subcategoriesReducer.js